import axios from 'axios'
import * as types from '@/actions/types'
import constants from '@/constants'

export function setStateSearchingSL(bool) {
  return {
    type: types.SET_SEARCHING,
    isSearching: bool,
  }
}

export function setResetResult(bool) {
  return {
    type: types.SET_RESET_RESULT,
    reset: bool,
  }
}

export function setResultVisible(bool) {
  return {
    type: types.SET_RESULT_VISIBLE,
    resultVisible: bool,
  }
}

export function setFilters(data) {
  return {
    type: types.SET_FILTERS,
    filters: data,
  }
}

export function setCurrentGeolocation(data) {
  return {
    type: types.SET_CURRENT_GEOLOCATION,
    payload: data,
  }
}

export function setCurrentPosition(data) {
  return {
    type: types.SET_CURRENT_POSITION,
    payload: data,
  }
}

export const resetStores = () => ({ type: types.RESET_STORES })

export function getStores(lat = 43.0707017, lng = 12.6195966) {
  const params = {
    params: {
      lat, // Latitude
      lon: lng, // Longitude
      r: 20000, // Radius
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_STORELOCATOR}`, params)
        .then((response) => {
          dispatch({
            type: types.GET_STORES,
            stores: response.data.results,
          })
          dispatch({
            type: types.SET_SEARCHING,
            isSearching: false,
          })
          dispatch({
            type: types.SET_RESET_RESULT,
            reset: false,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getStoresAll() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_STORELOCATOR_ALL)
        .then((response) => {
          dispatch({
            type: types.GET_STORES,
            stores: response.data.results,
          })
          dispatch({
            type: types.SET_SEARCHING,
            isSearching: false,
          })
          dispatch({
            type: types.SET_RESET_RESULT,
            reset: false,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
